export type HeaderFeaturesType = {
	showMove: boolean;
	showArchive: boolean;
	showCopy: boolean;
	showBreadcrumbs: boolean;
	/** Renders the access-link title in place of the breadcrumbs, when one is supplied. */
	showReplacementAccessLinkTitle?: boolean;
	showInlineRename?: boolean;
	showFavourite?: boolean;
	showShare?: boolean;
	showMainActions?: boolean;
	showMoreActions?: boolean;
	showClassificationMenuAction?: boolean;
	showContentRestrictions?: boolean;
	showWatchDialog?: boolean;
	showLastEdited?: boolean;
	/** Explicit opt-in for the supplied zoom controls. */
	showZoomControls?: boolean;
	showPresence?: boolean;
	showWhiteboardTeammate?: boolean;
};

export const DEFAULT_HEADER_FEATURES: HeaderFeaturesType = {
	showMove: true,
	showArchive: true,
	showCopy: true,
	showBreadcrumbs: true,
	showReplacementAccessLinkTitle: true,
	showInlineRename: true,
	showFavourite: true,
	showShare: true,
	showMainActions: true,
	showMoreActions: true,
	showClassificationMenuAction: false,
	showContentRestrictions: true,
	showWatchDialog: true,
	showLastEdited: true,
	showZoomControls: false,
	showPresence: true,
	showWhiteboardTeammate: true,
};
